import { QueryClientProvider } from '@tanstack/react-query';
import React, { PropsWithChildren } from 'react';

import { useGetQueryClient } from '@/config/useGetQueryClient.util.ts';

export const QueryClientWrapper: React.FC<PropsWithChildren> = props => {
  const queryClient = useGetQueryClient();

  return (
    <>
      <QueryClientProvider client={queryClient}>{props.children}</QueryClientProvider>
    </>
  );
};
